/** Category grid (Shop by Category) — align naming with home analytics spec. */
export const HOME_PAGE_CATEGORY_CARD_CLICKED = 'Home Page Category Card Clicked';

export const NEW_HOME_CATEGORY_CARDS_SECTION_NAME = 'Category Cards';

export function homePageCategoryCardClickEventProperties(options: {
  categoryName: string;
  position: number;
}): Record<string, string | number> {
  return {
    'Category Name': options.categoryName,
    'Section Name': NEW_HOME_CATEGORY_CARDS_SECTION_NAME,
    Position: options.position,
  };
}
